export default __webpack_public_path__ + "static/media/2.2098e5e9.jpg";